import React from 'react'
import { Grid, FormHelperText, InputLabel, Rating } from '@mui/material'
import { Controller, useFormContext } from 'react-hook-form'
import useStyles from './styles'

export function ControlledRating({
  label,
  name,
  required = false,
  hasError = false,
  disabled = false,
  className,
  ...props
}) {
  const styles = useStyles()
  const {
    control,
    formState: { errors },
  } = useFormContext()

  const error = !!errors[name] || hasError

  return (
    <Grid className={styles.container}>
      {label && (
        <InputLabel shrink className={styles.label}>
          {label}
          {required && <span className={styles.required}>*</span>}
        </InputLabel>
      )}

      <Controller
        name={name}
        control={control}
        rules={{
          required: { value: required, message: 'Esse campo é obrigatório' },
          validate: value => {
            if (!required) return true
            return value > 0 || 'Esse campo é obrigatório'
          },
        }}
        render={({ value, onChange, onBlur }) => (
          <Rating
            className={`${styles.rating} ${className}`}
            value={value ?? 0}
            onChange={(event, newValue) => onChange(newValue)}
            precision={0.5}
            disabled={disabled}
            onBlur={onBlur}
            {...props}
          />
        )}
      />

      {errors?.[name]?.message && (
        <FormHelperText className={styles.errorMessage} error={error}>
          {errors[name]?.message}
        </FormHelperText>
      )}
    </Grid>
  )
}
